'use client';
import { centsToDecimal, formatMoney } from '@campaign-manager/core/lib/utils';
import { useLocalization } from '@campaign-manager/feature/context/Localization';

import Value from '../Value';

interface Props {
  value: number | null | undefined;
  currency?: string | null | undefined;
  locale?: string | null | undefined;
  placeholder?: string;
}

export default function CentsValue({ value, placeholder }: Props) {
  const { currency, numberFormatLocale: locale } = useLocalization();
  return (
    <Value
      value={CentsString({ value, currency, locale })}
      placeholder={placeholder}
    />
  );
}

export function CentsString({ value, currency, locale }: Props) {
  return value
    ? formatMoney(centsToDecimal(value), currency ?? undefined, locale ?? undefined)
    : undefined;
}
